// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"lJ-z","carouselContainer":"mJ-z"};